import { CloseSalesOrderApi } from "api"
import {
  Alert,
  CreateButton,
  CRUDLayout,
  DataStatus,
  FilterButton,
  InputSearch,
  Pagination,
  ReadButton,
  Table,
  Td,
  Th,
  ThFixed,
} from "components"
import { saveAs } from "file-saver"
import { useEffect, useState } from "react"
import { ButtonGroup } from "react-bootstrap"
import { useHistory, useLocation } from "react-router-dom"
import { DateConvert, DecimalConvert, TableNumber } from "utilities"
import { ModalFilter } from "./section"

const CloseSalesOrderList = ({ setNavbarTitle }) => {
  const history = useHistory();
  const location = useLocation();

  const createAlert = location?.state?.alert?.variant;

  const [isPageLoading, setIsPageLoading] = useState(true);
  const [dataSalesOrder, setDataSalesOrder] = useState([]);
  const [showModalFilter, setShowModalFilter] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const [dataFilter, setDataFilter] = useState({
    filter: {
      active: location?.state?.closeSalesOrder?.filter?.active,
      tgl_sales_order_mulai:
        location?.state?.closeSalesOrder?.filter?.tgl_sales_order_mulai,
      tgl_sales_order_selesai:
        location?.state?.closeSalesOrder?.filter?.tgl_sales_order_selesai,
      tgl_close_sales_order_mulai:
        location?.state?.closeSalesOrder?.filter?.tgl_close_sales_order_mulai,
      tgl_close_sales_order_selesai:
        location?.state?.closeSalesOrder?.filter?.tgl_close_sales_order_selesai,
      id_customer: location?.state?.closeSalesOrder?.filter?.id_customer,
    },
    pagination: {
      page: location?.state?.closeSalesOrder?.filter?.page ?? "1",
      dataLength: location?.state?.closeSalesOrder?.filter?.dataLength ?? "10",
      totalPage: location?.state?.closeSalesOrder?.filter?.totalPage ?? "1",
      dataCount: location?.state?.closeSalesOrder?.filter?.dataCount ?? "0",
    },
  });
  const [searchConfig, setSearchConfig] = useState({
    status: false,
    key: "",
  });
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: "primary",
    text: "",
  });
  const [searchTime, setSearchTime] = useState(null);

  const getInitialData = () => {
    setIsPageLoading(true);

    CloseSalesOrderApi.get({
      q: searchConfig.key,
      page: dataFilter?.pagination?.page,
      per_page: dataFilter?.pagination?.dataLength,
      tgl_sales_order_mulai: dataFilter?.filter?.tgl_sales_order_mulai,
      tgl_sales_order_selesai: dataFilter?.filter?.tgl_sales_order_selesai,
      tgl_close_sales_order_mulai:
        dataFilter?.filter?.tgl_close_sales_order_mulai,
      tgl_close_sales_order_selesai:
        dataFilter?.filter?.tgl_close_sales_order_selesai,
      id_customer: dataFilter?.filter?.id_customer,
    })
      .then(({ data }) => {
        setDataSalesOrder(data?.data ?? []);
        setDataFilter({
          ...dataFilter,
          pagination: {
            ...dataFilter.pagination,
            dataCount: data?.data_count,
            totalPage: data?.total_page,
          },
        });
      })
      .catch((err) =>
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Data gagal dimuat!",
        })
      )
      .finally(() => setIsPageLoading(false));
  };

  const onInputSearchChange = (e) => {
    const key = e.target.value;
    if (searchTime) clearTimeout(searchTime);
    setSearchTime(
      setTimeout(() => {
        setSearchConfig({
          ...searchConfig,
          key: e.target.value,
        });
        setDataFilter({
          ...dataFilter,
          pagination: {
            ...dataFilter.pagination,
            page: "1",
            dataLength: "10",
            totalPage: "1",
            dataCount: "0",
          },
        });
        setAlertConfig({
          show: key ? true : false,
          variant: "primary",
          text: "Hasil dari pencarian: " + key,
        });
      }, 750)
    );
  };

  useEffect(() => {
    setNavbarTitle("Close Sales Order");
    if (createAlert !== undefined) {
      // setShowAlert(true);
      setAlertConfig({
        variant: location?.state?.alert?.variant,
        text: location?.state?.alert?.text.alert,
        show: true,
      });

      getInitialData();
      history.replace((createAlert = undefined));
    } else {
      return getInitialData(false);
    }
  }, [
    setNavbarTitle,
    searchConfig.key,
    dataFilter?.pagination?.page,
    dataFilter?.pagination?.dataLength,
    dataFilter?.filter?.active,
    dataFilter?.filter?.tgl_sales_order_mulai,
    dataFilter?.filter?.tgl_sales_order_selesai,
    dataFilter?.filter?.tgl_close_sales_order_mulai,
    dataFilter?.filter?.tgl_close_sales_order_selesai,
    dataFilter?.filter?.id_customer,
  ]);

  const PageContent = () => {
    const DataTable = () => (
      <Table>
        <thead>
          <tr>
            <ThFixed>No</ThFixed>
            <ThFixed>Aksi</ThFixed>
            <ThFixed>Informasi Close Sales Order</ThFixed>
            <ThFixed>Informasi Sales Order</ThFixed>
            <Th>Customer</Th>
            <Th>Barang Jadi</Th>
            <Th>List Barang Jadi Yang Terkirim</Th>
            <Th>List Barang Jadi Yang Telah Di Realisasi</Th>
          </tr>
        </thead>
        <tbody>
          {dataSalesOrder.length > 0 &&
            dataSalesOrder.map((val, index) => (
              <tr key={index}>
                <Td textCenter>
                  {TableNumber(
                    dataFilter?.pagination?.page,
                    dataFilter?.pagination?.dataLength,
                    index
                  )}
                </Td>
                <Td>
                  <ButtonGroup size="sm">
                    <ReadButton
                      onClick={() =>
                        history.push(
                          "/sls/transaksi/close-sales-order/detail/" +
                            val.id_sales_order,
                          {
                            ...location?.state,
                            closeSalesOrder: dataFilter,
                            is_spk: val.is_spk,
                          }
                        )
                      }
                    />
                  </ButtonGroup>
                </Td>

                <Td className="text-nowrap">
                  <div>
                    {val.tgl_close_sales_order
                      ? DateConvert(new Date(val.tgl_close_sales_order))
                          .defaultDMY
                      : "-"}
                  </div>
                  <div>{val.no_close_sales_order ?? "-"}</div>
                </Td>
                <Td className="text-nowrap">
                  <div>
                    {val.tgl_sales_order
                      ? DateConvert(new Date(val.tgl_sales_order)).defaultDMY
                      : "-"}
                  </div>
                  <div>{val.no_sales_order ?? "-"}</div>
                </Td>
                <Td className="text-nowrap">
                  <div>{val.nama_customer}</div>
                </Td>
                <Td>
                  <div>
                    {val?.barang_jadi?.length > 0 ? (
                      <ul className="pl-3">
                        {val?.barang_jadi.map((e, i) => (
                          <li key={i}>
                            {e.nama_item
                              ? `${e.nama_item} x ${
                                  e.qty ? DecimalConvert(e.qty).getWithComa : 0
                                } ${e.nama_satuan}`
                              : "-"}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      "-"
                    )}
                  </div>
                </Td>
                <Td>
                  <div>
                    {val?.terkirim?.length > 0 ? (
                      <ul className="pl-3">
                        {val?.terkirim.map((e, i) => (
                          <li key={i}>
                            {e.nama_item
                              ? `${e.nama_item} x ${
                                  e.qty ? DecimalConvert(e.qty).getWithComa : 0
                                } ${e.nama_satuan}`
                              : "-"}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      "-"
                    )}
                  </div>
                </Td>
                <Td>
                  <div>
                    {val?.produksi?.length > 0 ? (
                      <ul className="pl-3">
                        {val?.produksi.map((e, i) => (
                          <li key={i}>
                            {e.nama_item
                              ? `${e.nama_item} x ${
                                  e.qty ? DecimalConvert(e.qty).getWithComa : 0
                                } ${e.nama_satuan}`
                              : "-"}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      "-"
                    )}
                  </div>
                </Td>
              </tr>
            ))}
        </tbody>
      </Table>
    );

    return (
      <>
        <b>List Data Close Sales Order</b>
        <DataTable />
        {!searchConfig.status && (
          <Pagination
            dataLength={dataFilter?.pagination?.dataLength}
            dataNumber={
              dataFilter?.pagination?.page *
                dataFilter?.pagination?.dataLength -
              dataFilter?.pagination?.dataLength +
              1
            }
            dataPage={
              dataFilter?.pagination?.dataCount <
              dataFilter?.pagination?.dataLength
                ? dataFilter?.pagination?.dataCount
                : dataFilter?.pagination?.page *
                  dataFilter?.pagination?.dataLength
            }
            dataCount={dataFilter?.pagination?.dataCount}
            currentPage={dataFilter?.pagination?.page}
            totalPage={dataFilter?.pagination?.totalPage}
            onPaginationChange={({ selected }) =>
              setDataFilter({
                ...dataFilter,
                pagination: {
                  ...dataFilter.pagination,
                  page: selected + 1,
                },
              })
            }
            onDataLengthChange={(e) =>
              setDataFilter({
                ...dataFilter,
                pagination: {
                  ...dataFilter.pagination,
                  page: 1,
                  dataLength: e.target.value,
                },
              })
            }
          />
        )}
      </>
    );
  };

  return (
    <CRUDLayout>
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <div className="d-flex mb-3">
            <InputSearch onChange={onInputSearchChange} />
            <FilterButton
              active={dataFilter?.filter?.active}
              onClick={() => setShowModalFilter(true)}
            />
          </div>
        </CRUDLayout.HeadSearchSection>
        <CRUDLayout.HeadButtonSection>
          <CreateButton
            onClick={() =>
              history.push("/sls/transaksi/close-sales-order/sales-order", {
                ...location?.state,
                closeSalesOrder: dataFilter,
              })
            }
          />
        </CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      <Alert
        show={alertConfig.show}
        variant={alertConfig.variant}
        text={alertConfig.text}
        showCloseButton={true}
        onClose={() =>
          setAlertConfig({
            ...alertConfig,
            show: false,
          })
        }
      />

      {/* Content */}
      {isPageLoading ? (
        <DataStatus loading={true} text="Memuat data . . ." />
      ) : (
        <PageContent />
      )}

      {showModalFilter && (
        <ModalFilter
          show={showModalFilter}
          setShow={setShowModalFilter}
          data={dataFilter}
          setData={setDataFilter}
        />
      )}
    </CRUDLayout>
  );
};
export default CloseSalesOrderList;
